export const apiUrl = process.env.NODE_ENV === 'production' ? 'https://api.chatway.ru' : 'http://api.chatway.lc'
export const appUrl = process.env.NODE_ENV === 'production' ? 'https://app.chatway.ru' : 'http://app.chatway.lc:3000'
export const baseURL = process.env.NODE_ENV === 'production' ? 'https://chatway.ru' : 'http://chatway.ru'
